module.exports = __webpack_public_path__ + "img/empty-icon.08e48d9e.png";